import { useEffect, useRef, useState } from "react";

const SchedulerModal = ({ url, onClose, type }) => {
  const iframeRef = useRef(null);
  const [currentUrl, setCurrentUrl] = useState(url);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setCurrentUrl(url);
    setIsLoading(true); // reset loading when a new URL is opened
  }, [url]);

  const handleIframeLoad = () => {
    const iframe = iframeRef.current;
    setIsLoading(false); // loading complete

    try {
      const iframeUrl = iframe?.contentWindow?.location.href;
      if (iframeUrl?.includes("confirmed=1")) {
        onClose(); // close on success
      }
    } catch (err) {
      // Cross-origin access likely; fallback logic or ignore
    }
  };

  if (!url) return null;

  return (
    <div className="scheduler-modal">
      <div
        className="sub-scheduler-modal"
        style={{
          backgroundColor:
            type === "pay"
              ? "#fdf3f3"
              : type === "free"
              ? "#f1fdf3"
              : "#ffffff",
        }}
      >
        <button onClick={onClose} className="modal-close-btn">
          ×
        </button>

        {isLoading && (
          <div className="overlay">
            <div className="loader"></div>
          </div>
        )}

        <iframe
          ref={iframeRef}
          onLoad={handleIframeLoad}
          src={currentUrl}
          title="Scheduler appointment booking"
          className="iframe-view"
        />
      </div>
    </div>
  );
};

export default SchedulerModal;
